// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrentStage_container__2Hy_g","questionContainer":"CurrentStage_questionContainer__13Tcx","optionsContainer":"CurrentStage_optionsContainer__KClq5"};